import CommandCenter from '../view/systemManage/command-center/command-center'
import Map from '../view/systemManage/command-center/command-center-map/command-center-map'
import Container from '../view/systemManage/command-center/comand-center-contaniner/comand-center-contaniner'
import Pending from '../view/systemManage/command-center/comand-center-contaniner/pending/pending'
import Processing from '../view/systemManage/command-center/comand-center-contaniner/processing/processing'
import Finish from '../view/systemManage/command-center/comand-center-contaniner/finish/finish'
import UpReport from '../view/systemManage/command-center/comand-center-contaniner/up-report/up-report'
import Participation from '../view/systemManage/command-center/comand-center-contaniner/participation/participation'


const command = {
    path: '/command',
    component: CommandCenter,
    redirect: '/command/map',
    children: [
        {
            path: '/command/map',
            name: 'commandMap',
            component: Map,
            meta: {
                title: '应急联动'
            }
        }, {
            path: '/command/contaniner',
            component: Container,
            redirect: '/command/pending',
            children: [
                {
                    path: '/command/pending',
                    name: 'pending',
                    component: Pending,
                    meta: {
                        title: '待处理'
                    }
                }, {
                    path: '/command/processing',
                    component: Processing,
                    name: 'processing',
                    meta: {
                        title: '处理中'
                    }
                }, {
                    path: '/command/finish',
                    name: 'finish',
                    component: Finish,
                    meta: {
                        title: '已完成'
                    }
                }, {
                    path: '/command/up-report',
                    name: 'upReport',
                    component: UpReport,
                    meta: {
                        title: '已上报'
                    }
                }, {
                    path: '/command/participation',
                    name: 'participation',
                    component: Participation,
                    meta: {
                        title: '已参与'
                    }
                },
            ]
        }
    ]
}

export default command
